import type { ReactNode, CSSProperties } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  as?: "div" | "p" | "section" | "h2";
  style?: CSSProperties;
};

/** Discourages copy/paste of stems; not a security boundary. */
export function NoCopyQuestionStem({ children, className = "", as: Tag = "div", style }: Props) {
  return (
    <Tag
      className={`select-none cursor-default whitespace-pre-wrap ${className}`}
      style={{ WebkitUserSelect: "none", userSelect: "none", ...style }}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
    >
      {children}
    </Tag>
  );
}

